// client/src/utilities/joyrideConfig.js
import { useTranslation } from 'react-i18next';

const useJoyrideConfig = () => {
  const { t } = useTranslation();

  const steps = [
    {
      target: '.agi-video',
      content: t('step1Content'),
      disableBeacon: true,
    },
    {
      target: '.header-options',
      content: t('step2Content'),
      disableBeacon: true,
    },
    {
      target: '.commencer',
      content: t('step3Content'),
      disableBeacon: true,
    },
  ];

  const joyrideProps = {
    steps: steps,
    continuous: true,
    showProgress: true,
    styles: {
      options: {
        arrowColor: '#e3ffeb',
        primaryColor: 'var(--francoflex)',
        fontSize: '1.5rem',
        textColor: 'var(--francoflex)',
      },
      tooltip: {
        fontSize: '1.5rem',
      },
    },
    locale: {
      back: t('back'),
      close: t('close'),
      last: t('last'),
      next: t('next'),
      nextLabelWithProgress: t('nextLabelWithProgress'),
      open: t('open'),
      skip: t('skip'),
    },
  };

  return joyrideProps;
};

export default useJoyrideConfig;